<div class="right-side right-side-bg p-5">
  <h2>Dashboard</h2>

  <div class="card mb-3">
    <div class="card-header"><h2>Events</h2></div>
    <div class="card-body">
      <div class="row">
        <!-- Row 1: Basic Stats -->
        <div class="col-md-3">
          <div class="card bg-gradient-primary box-shadow mb-2 dash-height">
            <div class="card-body">
              <h5 class="card-title fs-51">Total Events</h5>
              <div class="d-flex align-items-center">
                <div class="fs-5">{{ totalEvents  }}</div>

                <button id="btnTotalEvents" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                  <i class="bi bi-calendar  fs-4"></i>
                  <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                </button>


              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card bg-gradient-success box-shadow mb-2 dash-height">
            <div class="card-body">
              <h5 class="card-title fs-51">Enrolled Successfully</h5>
              <div class="d-flex align-items-center">
                <div class="fs-5">{{ enrolledSuccessfully }}</div>
                <button id="btnEnrolledSuccessfully" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                  <i class="bi bi-check-circle-fill fs-4"></i>
                  <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                </button>


              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card bg-gradient-warning box-shadow mb-2 dash-height">
            <div class="card-body">
              <h5 class="card-title fs-51">Attended Events</h5>
              <div class="d-flex align-items-center">
                <div class="fs-5">{{participantsAttended}}</div>
                <button id="btnAttendedEvents" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                  <i class="bi bi-calendar-event fs-4"></i>
                  <!--<i class="fa fa-info-circle ms-auto fs-4" aria-hidden="true"></i>-->
                </button>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!--*****************************************Commented for 1st live**********************************************************-->
  <!--<div class="card mb-3">
    <div class="card-header"><h2>Grievance</h2></div>
    <div class="card-body">
       Event Section 
      <div class="row">
        <div class="col-md-3">
          <div class="card bg-gradient-primary box-shadow mb-2 dash-height">
            <div class="card-body">
              <h5 class="card-title fs-5">Total</h5>
              <div class="d-flex align-items-center">
                <div class="fs-5">{{totalGrievances}}</div>
                <button id="btnTotalGrievances" class="btn-link bg-transparent border-0 text-white ms-auto " (click)="CardRedirection($event)">
                  <i class="bi bi-person-plus fs-4"></i>
                </button>
              </div>
              <p class="card-text mt-2">

              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card bg-gradient-success box-shadow mb-2 dash-height">
            <div class="card-body">
              <h5 class="card-title fs-5">Disposed</h5>
              <div class="d-flex align-items-center">
                <div class="fs-5">{{disposedGrievances}}</div>
                <button id="btnDisposedGrievances" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                  <i class="bi bi-check-circle fs-4"></i>
                </button>
              </div>
              <p class="card-text mt-2">

              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card bg-gradient-warning box-shadow mb-2 dash-height">
            <div class="card-body">
              <h5 class="card-title fs-5">Pending</h5>
              <div class="d-flex align-items-center">
                <div class="fs-5">{{pendingGrievances}}</div>
                <button id="btnPendingGrievances" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                  <i class="bi bi-hourglass fs-4"></i>
                  
                </button>
              </div>
              <p class="card-text mt-2">

              </p>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card bg-gradient-danger box-shadow mb-2 dash-height">
            <div class="card-body">
              <h5 class="card-title fs-5">Rejected</h5>
              <div class="d-flex align-items-center">
                <div class="fs-5">{{rejectedGrievances}}</div>
                <button id="btnRejectedGrievances" class="btn-link bg-transparent border-0 text-white ms-auto" (click)="CardRedirection($event)">
                  <i class="bi bi-x-circle fs-4"></i>
                  
                </button>
              </div>
              <p class="card-text mt-2">

              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>-->
</div>


